import { useEffect, useRef, useState } from "react";

export const useDynamicHeight = (dependency?: any) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (elementRef.current) {
        const viewportHeight = window.innerHeight;
        const elementTop = elementRef.current.getBoundingClientRect().top;
        const dynamicHeight = viewportHeight - elementTop;
        setHeight(dynamicHeight - 12);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [dependency]);

  return { ref: elementRef, height };
};
